const sourceSansProRegular = {
  fontFamily: 'Source Sans Pro',
  fontStyle: 'normal',
  fontWeight: 400,
  src: `url('/fonts/SourceSansPro-Regular.otf') format('opentype')`,
};

const sourceSansProSemiBold = {
  fontFamily: 'Source Sans Pro',
  fontStyle: 'normal',
  fontWeight: 600,
  src: `url('/fonts/SourceSansPro-Semibold.otf') format('opentype')`,
};

const sourceSansProBold = {
  fontFamily: 'Source Sans Pro',
  fontStyle: 'normal',
  fontWeight: 700,
  src: `url('/fonts/SourceSansPro-Bold.otf') format('opentype')`,
};

const sourceSansProIt = {
  fontFamily: 'Source Sans Pro',
  fontStyle: 'italic',
  fontWeight: 400,
  src: `url('/fonts/SourceSansPro-It.otf') format('opentype')`,
};

const sourceSansProSemiBoldIt = {
  fontFamily: 'Source Sans Pro',
  fontStyle: 'italic',
  fontWeight: 600,
  src: `url('/fonts/SourceSansPro-SemiboldIt.otf') format('opentype')`,
};

const sourceSansProBoldIt = {
  fontFamily: 'Source Sans Pro',
  fontStyle: 'italic',
  fontWeight: 700,
  src: `url('/fonts/SourceSansPro-BoldIt.otf') format('opentype')`,
};

const latoRegular = {
  fontFamily: 'Lato',
  fontStyle: 'normal',
  fontWeight: 400,
  src: `url('/fonts/Lato-Regular.ttf') format('truetype')`,
};

const latoBold = {
  fontFamily: 'Lato',
  fontStyle: 'normal',
  fontWeight: 700,
  src: `url('/fonts/Lato-Bold.ttf') format('truetype')`,
};

const latoIt = {
  fontFamily: 'Lato',
  fontStyle: 'italic',
  fontWeight: 400,
  src: `url('/fonts/Lato-Italic.ttf') format('truetype')`,
};

const latoBoldIt = {
  fontFamily: 'Lato',
  fontStyle: 'italic',
  fontWeight: 700,
  src: `url('/fonts/Lato-BoldItalic.ttf') format('truetype')`,
};

export default [
  sourceSansProRegular,
  sourceSansProSemiBold,
  sourceSansProBold,
  sourceSansProIt,
  sourceSansProSemiBoldIt,
  sourceSansProBoldIt,
  latoRegular,
  latoBold,
  latoIt,
  latoBoldIt,
];
